import script from "./ReasonsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ReasonsSection.vue?vue&type=script&setup=true&lang=js"

import "./ReasonsSection.vue?vue&type=style&index=0&id=ff61e73e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff61e73e"]])

export default __exports__